import * as z from "zod";

export const getTaxIdRequirements = {
  name: "getTaxIdRequirements" as const,
  input: z.null(),
  output: z.object({
    /** Whether the team has any return destinations at all, so the UI can tell
     * "none resolved" from "resolved, none need a tax ID". */
    hasDestinations: z.boolean(),
    /** One entry per destination needing a tax ID; the rest are omitted. */
    destinations: z.array(
      z.object({
        country: z.string(),
        requirements: z.array(
          z.object({
            taxIdType: z.enum(["EORI", "VAT", "EIN"]),
            issuingAuthority: z.string(),
            /** Whether the label path would find a number for this slot. */
            satisfied: z.boolean(),
          }),
        ),
      }),
    ),
  }),
};
